import Grid from '@material-ui/core/Grid';
import { TOOLBAR_HEIGHT } from 'components/Layout';
import React from 'react';

import Hints from '.';

import type { hintTypes } from '.';

export const NewProductHint = ({ type }: { type: hintTypes }) => {
  return (
    <Grid item xs={12} style={{ top: TOOLBAR_HEIGHT, position: 'sticky' }}>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Hints type={type} can />
        </Grid>
        <Grid item xs={12}>
          <Hints type={type} cant />
        </Grid>
      </Grid>
    </Grid>
  );
};
